var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/react-vt.ts
import {
  useState,
  useReducer,
  useSyncExternalStore,
  startTransition as reactStartTransition,
  useEffect,
  useTransition
} from "react";
var suspendersCount = 0;
var observers = /* @__PURE__ */ new Set();
var didCaptureNewState = null;
function suspendViewTransitionCapture() {
  suspendersCount++;
}
function resumeViewTransitionCapture() {
  !--suspendersCount;
  observers.forEach((observer) => observer());
}
var _a;
var areViewTransitionsSupported = typeof ((_a = globalThis.document) == null ? void 0 : _a.startViewTransition) === "function";
function useBlockRendering(blocked) {
  const [, forceRender] = useReducer((x) => x + 1, 0);
  if (blocked) {
    const deadline = performance.now() + 1;
    while (performance.now() < deadline) {
    }
  }
  useEffect(() => {
    if (blocked)
      forceRender();
  });
}
function SuspendViewTransition() {
  useEffect(() => {
    suspendViewTransitionCapture();
    return () => resumeViewTransitionCapture();
  }, []);
  return null;
}
function useViewTransition() {
  const [transitionState, setTransitionState] = useState("idle");
  useSyncExternalStore((onStoreChange) => {
    observers.add(onStoreChange);
    return () => {
      observers.delete(onStoreChange);
    };
  }, () => suspendersCount, () => 0);
  useEffect(() => {
    if (didCaptureNewState && !suspendersCount) {
      didCaptureNewState();
      didCaptureNewState = null;
    }
  });
  useBlockRendering(transitionState === "capturing-old");
  function startViewTransition(updateCallback) {
    if (!areViewTransitionsSupported) {
      if (updateCallback)
        reactStartTransition(updateCallback);
      return;
    }
    suspendViewTransitionCapture();
    setTransitionState("capturing-old");
    const transition = document.startViewTransition(() => new Promise((resolve) => __async(this, null, function* () {
      setTransitionState("capturing-new");
      resumeViewTransitionCapture();
      if (updateCallback)
        yield updateCallback();
      didCaptureNewState = resolve;
    })));
    transition.finished.then(() => {
      setTransitionState("idle");
    });
    transition.ready.then(() => {
      setTransitionState("animating");
    }).catch((e) => {
      console.error(e);
      setTransitionState("skipped");
    });
  }
  return {
    transitionState,
    startViewTransition,
    suspendViewTransitionCapture,
    resumeViewTransitionCapture
  };
}

// src/next-vt.tsx
import {
  useEffect as useEffect2,
  Suspense
} from "react";
import React from "react";
function useNextRouterViewTransitions({ events }) {
  const {
    startViewTransition,
    suspendViewTransitionCapture: suspendViewTransitionCapture2,
    resumeViewTransitionCapture: resumeViewTransitionCapture2
  } = useViewTransition();
  useEffect2(() => {
    function beginNavigation() {
      startViewTransition();
      suspendViewTransitionCapture2();
    }
    ;
    function endNavigation() {
      resumeViewTransitionCapture2();
    }
    events.on("routeChangeStart", beginNavigation);
    events.on("routeChangeComplete", endNavigation);
    return () => {
      events.off("routeChangeStart", beginNavigation);
      events.off("routeChangeComplete", endNavigation);
    };
  }, []);
}
function RouterEventsNotifier() {
  return null;
}
var EnableNextAppRouterViewTransitions = () => {
  return /* @__PURE__ */ React.createElement(Suspense, { fallback: /* @__PURE__ */ React.createElement(SuspendViewTransition, null) }, /* @__PURE__ */ React.createElement(RouterEventsNotifier, null));
};
export {
  EnableNextAppRouterViewTransitions,
  SuspendViewTransition,
  useNextRouterViewTransitions,
  useViewTransition
};
